import { DateTime } from "effect";

import { resolveCurrentOriginPairingUrl, resolveDesktopPairingUrl } from "~/pairingUrl";

/**
 * Presentation helpers shared by every page that shows a pairing link (the
 * mobile pairing page and the add-a-machine page). Both need the same URL
 * resolution order and the same expiry normalization; they lived as
 * byte-identical copies in each page until that was noticed.
 */

/** Where a machine should open the credential: the desktop exposure endpoint
 * when this tab runs inside the desktop shell, otherwise this origin's
 * `/login#token=...` page. */
export async function resolvePairingUrl(credential: string): Promise<string> {
  const exposureState = await window.desktopBridge?.getServerExposureState?.();
  if (exposureState?.endpointUrl) {
    return resolveDesktopPairingUrl(exposureState.endpointUrl, credential);
  }
  return resolveCurrentOriginPairingUrl(credential);
}

/** The pairing contract decodes expiry as an Effect DateTime; every UI that
 * shows or stores it wants an ISO string. */
export function normalizeExpiresAt(expiresAt: unknown): string {
  if (typeof expiresAt === "string") {
    return expiresAt;
  }
  return DateTime.formatIso(expiresAt as DateTime.Utc);
}
